import styled from "styled-components";
import { defaults } from "../../../../styles";

export const Container = styled(defaults.Container)`
  flex: 1;
  flex-direction: row;
  height: 100%;
  max-height: 75px;
`;

export const SmileLabel = styled.label`
  padding: 10px;

  opacity: ${({ checked, selected }) =>
    checked || !selected ? 1 : defaults.opacityNotSelected};
`;
